import React from 'react'
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { ApolloQueryResult } from '@apollo/client'

interface TableSorterProps {
  type: 'asc' | 'desc'
  onClick: () => Promise<ApolloQueryResult<any>> | undefined | void
  isActive: boolean
}

const TableSorter = ({ type, onClick, isActive }: TableSorterProps) => {
  const isAscending = type === 'asc'

  return (
    <Tooltip
      title={`Click to sort to ${isAscending ? 'ascending' : 'descending'}`}
      placement={isAscending ? 'top' : 'bottom'}
    >
      {isAscending ? (
        <AscSorterIcon onClick={onClick} className={isActive ? 'active' : ''} />
      ) : (
        <DescSorterIcon
          onClick={onClick}
          className={isActive ? 'active' : ''}
        />
      )}
    </Tooltip>
  )
}

const sorterIconStyles = css`
  svg > path {
    fill: #bfbfbf;
  }

  &.active svg > path {
    fill: #d092dd;
  }
`

const AscSorterIcon = styled(CaretUpOutlined)`
  ${sorterIconStyles}
`

const DescSorterIcon = styled(CaretDownOutlined)`
  ${sorterIconStyles}
`

export default TableSorter
